import React, { useEffect, useRef, useState } from 'react';

// Duotone investment SVG icons — gold primary on white cards
const InvestmentIcon = ({ size = 44, hovered = false }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 30c0 0 4-3 10-3h6l4-1" stroke={hovered ? 'white' : '#0B1F3B'} strokeWidth="2" strokeLinecap="round" fill="none"/>
    <path d="M8 34c2 1 6 2 10 2s10-2 14-5l4-4" stroke={hovered ? 'white' : '#0B1F3B'} strokeWidth="2" strokeLinecap="round" fill="none"/>
    <path d="M22 28V18" stroke={hovered ? 'white' : '#0B1F3B'} strokeWidth="2" strokeLinecap="round"/>
    <path d="M22 22c-2-3-6-4-6-4s1 4 6 4z" fill={hovered ? 'rgba(255,255,255,0.8)' : '#D4A520'}/>
    <path d="M22 20c2-3 6-4 6-4s-1 4-6 4z" fill={hovered ? 'rgba(255,255,255,0.8)' : '#D4A520'}/>
    <circle cx="22" cy="13" r="6" fill={hovered ? 'rgba(255,255,255,0.9)' : '#D4A520'}/>
    <text x="22" y="17" textAnchor="middle" fontSize="8" fill={hovered ? '#D4A520' : '#0B1F3B'} fontWeight="bold">$</text>
    <path d="M30 24l4-6 4 2" stroke={hovered ? 'rgba(255,255,255,0.8)' : '#D4A520'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M34 18l4-2" stroke={hovered ? 'rgba(255,255,255,0.8)' : '#D4A520'} strokeWidth="2" strokeLinecap="round" fill="none"/>
  </svg>
);

const AIStrategyIcon = ({ size = 44, hovered = false }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="14" y="32" width="16" height="4" rx="2" fill={hovered ? 'white' : '#0B1F3B'}/>
    <rect x="17" y="28" width="10" height="4" rx="1" fill={hovered ? 'white' : '#0B1F3B'}/>
    <ellipse cx="22" cy="24" rx="5" ry="6" fill={hovered ? 'white' : '#0B1F3B'}/>
    <circle cx="22" cy="16" r="4" fill={hovered ? 'white' : '#0B1F3B'}/>
    <circle cx="22" cy="13" r="2.5" fill={hovered ? 'rgba(255,255,255,0.6)' : '#D4A520'}/>
    <circle cx="32" cy="20" r="7" fill={hovered ? 'rgba(255,255,255,0.9)' : '#D4A520'}/>
    <text x="32" y="24" textAnchor="middle" fontSize="9" fill={hovered ? '#D4A520' : '#0B1F3B'} fontWeight="bold">$</text>
    <path d="M30 10l6-4" stroke={hovered ? 'rgba(255,255,255,0.8)' : '#D4A520'} strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M34 6l2 0 0 2" stroke={hovered ? 'rgba(255,255,255,0.8)' : '#D4A520'} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PortfolioIcon = ({ size = 44, hovered = false }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 14c0-2 1.5-3 3-3h8l3 3h15c1.5 0 3 1 3 3v16c0 2-1.5 3-3 3H9c-1.5 0-3-1-3-3V14z" fill={hovered ? 'white' : '#0B1F3B'}/>
    <path d="M6 18h32" stroke={hovered ? '#D4A520' : '#D4A520'} strokeWidth="2"/>
    <circle cx="20" cy="28" r="7" fill={hovered ? 'rgba(255,255,255,0.9)' : '#D4A520'}/>
    <text x="20" y="32" textAnchor="middle" fontSize="10" fill={hovered ? '#D4A520' : '#0B1F3B'} fontWeight="bold">$</text>
    <rect x="28" y="30" width="3" height="5" rx="1" fill={hovered ? 'rgba(255,255,255,0.8)' : '#D4A520'}/>
    <rect x="32" y="27" width="3" height="8" rx="1" fill={hovered ? 'rgba(255,255,255,0.8)' : '#D4A520'}/>
    <rect x="36" y="24" width="3" height="11" rx="1" fill={hovered ? 'rgba(255,255,255,0.8)' : '#D4A520'}/>
  </svg>
);

const AcademyIcon = ({ size = 44, hovered = false }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 6h18l8 8v26H10V6z" fill={hovered ? 'white' : '#0B1F3B'}/>
    <path d="M28 6v8h8" fill={hovered ? 'rgba(255,255,255,0.6)' : '#D4A520'}/>
    <circle cx="20" cy="24" r="7" fill={hovered ? 'rgba(255,255,255,0.9)' : '#D4A520'}/>
    <text x="20" y="28" textAnchor="middle" fontSize="10" fill={hovered ? '#D4A520' : '#0B1F3B'} fontWeight="bold">$</text>
    <circle cx="32" cy="32" r="6" fill={hovered ? 'rgba(255,255,255,0.9)' : '#D4A520'}/>
    <path d="M29 32l2 2 4-4" stroke={hovered ? '#D4A520' : '#0B1F3B'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CommunityIcon = ({ size = 44, hovered = false }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 28c0 0 2-4 6-6l4-1" stroke={hovered ? 'white' : '#0B1F3B'} strokeWidth="3" strokeLinecap="round" fill="none"/>
    <path d="M4 32c1 2 4 4 8 4" stroke={hovered ? 'white' : '#0B1F3B'} strokeWidth="3" strokeLinecap="round" fill="none"/>
    <path d="M38 28c0 0-2-4-6-6l-4-1" stroke={hovered ? 'white' : '#0B1F3B'} strokeWidth="3" strokeLinecap="round" fill="none"/>
    <path d="M40 32c-1 2-4 4-8 4" stroke={hovered ? 'white' : '#0B1F3B'} strokeWidth="3" strokeLinecap="round" fill="none"/>
    <circle cx="22" cy="22" r="10" fill={hovered ? 'rgba(255,255,255,0.9)' : '#D4A520'}/>
    <text x="22" y="27" textAnchor="middle" fontSize="13" fill={hovered ? '#D4A520' : '#0B1F3B'} fontWeight="bold">$</text>
  </svg>
);

const MarketplaceIcon = ({ size = 44, hovered = false }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 32c0 0 4-3 10-3" stroke={hovered ? 'white' : '#0B1F3B'} strokeWidth="3" strokeLinecap="round" fill="none"/>
    <path d="M6 36c2 2 6 3 10 3s10-2 12-4" stroke={hovered ? 'white' : '#0B1F3B'} strokeWidth="3" strokeLinecap="round" fill="none"/>
    <ellipse cx="26" cy="22" rx="11" ry="13" fill={hovered ? 'rgba(255,255,255,0.9)' : '#D4A520'}/>
    <path d="M22 10c0 0 1-3 4-3s4 3 4 3" stroke={hovered ? '#D4A520' : '#0B1F3B'} strokeWidth="2" strokeLinecap="round" fill="none"/>
    <text x="26" y="27" textAnchor="middle" fontSize="12" fill={hovered ? '#D4A520' : '#0B1F3B'} fontWeight="bold">$</text>
    <path d="M20 14c2-2 8-2 10 0" stroke={hovered ? '#D4A520' : '#0B1F3B'} strokeWidth="2" strokeLinecap="round" fill="none"/>
  </svg>
);

const ICON_MAP = {
  'Investment Opportunities': InvestmentIcon,
  'WIN AI Assistant': AIStrategyIcon,
  'Portfolio Tracker': PortfolioIcon,
  'WIN Academy': AcademyIcon,
  'Community Hub': CommunityIcon,
  'WIN Marketplace': MarketplaceIcon,
};

const FEATURES = [
  {
    title: 'Investment Opportunities',
    description: 'Access vetted, women-led investment deals curated by our expert advisory board.',
    link: 'Explore Deals',
    span: 'md:col-span-2',
  },
  {
    title: 'WIN AI Assistant',
    description: 'Claude-powered wealth planning and real-time stock analysis at your fingertips.',
    link: 'Try AI',
    span: '',
  },
  {
    title: 'Portfolio Tracker',
    description: 'Track holdings, ROI, and asset allocation in real time with beautiful visualizations.',
    link: 'Track Now',
    span: '',
  },
  {
    title: 'WIN Academy',
    description: 'Courses from Investing 101 to Venture Capital — learn at your own pace.',
    link: 'Start Learning',
    span: '',
  },
  {
    title: 'Community Hub',
    description: 'Connect with 5,000+ women investors nationwide through forums, events, and mentorship.',
    link: 'Join Community',
    span: '',
  },
  {
    title: 'WIN Marketplace',
    description: 'Shop women-owned products and services. Every purchase supports our community.',
    link: 'Shop Now',
    span: 'md:col-span-2',
  },
];

const FeatureCard = ({ title, description, link, span, index, visible }) => {
  const IconComponent = ICON_MAP?.[title];
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={`${span} relative bg-white rounded-2xl p-6 cursor-pointer overflow-hidden ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{
        transitionDelay: `${index * 80}ms`,
        transition: 'opacity 500ms ease, transform 500ms ease, box-shadow 300ms cubic-bezier(0.4,0,0.2,1)',
        transform: visible ? (hovered ? 'translateY(-6px)' : 'translateY(0)') : 'translateY(32px)',
        boxShadow: hovered
          ? '0 12px 40px rgba(212,165,32,0.25), 0 4px 16px rgba(0,0,0,0.08)'
          : '0 2px 12px rgba(0,0,0,0.06)',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Gold top accent — brightens on hover */}
      <div
        className="absolute top-0 left-0 right-0 h-1 rounded-t-2xl"
        style={{
          background: hovered
            ? '#D4A520' :'linear-gradient(to right, rgba(212,165,32,0.4), rgba(240,200,48,0.4))',
          transition: 'background 300ms cubic-bezier(0.4,0,0.2,1)',
        }}
      />
      {/* Hover glow overlay */}
      <div
        className="absolute inset-0 rounded-2xl pointer-events-none"
        style={{
          background: 'linear-gradient(135deg, rgba(212,165,32,0.05) 0%, transparent 60%)',
          opacity: hovered ? 1 : 0,
          transition: 'opacity 300ms cubic-bezier(0.4,0,0.2,1)',
        }}
      />

      <div className="relative z-10">
        {/* Icon container — bg transitions from navy to gold on hover */}
        <div
          className="w-16 h-16 rounded-xl flex items-center justify-center mb-4 shadow-md"
          style={{
            background: hovered ? '#D4A520' : '#0B1F3B',
            transition: 'background 300ms cubic-bezier(0.4,0,0.2,1), transform 300ms cubic-bezier(0.4,0,0.2,1)',
            transform: hovered ? 'scale(1.08)' : 'scale(1)',
          }}
        >
          {IconComponent && <IconComponent size={44} hovered={hovered} />}
        </div>
        {/* Title — transitions to gold on hover */}
        <h3
          className="font-bold text-lg mb-2"
          style={{
            fontFamily: 'Cormorant Garamond, serif',
            color: hovered ? '#D4A520' : '#0B1F3B',
            transition: 'color 300ms cubic-bezier(0.4,0,0.2,1)',
          }}
        >
          {title}
        </h3>
        <p className="text-[#0B1F3B]/60 text-sm leading-relaxed mb-4">{description}</p>
        {/* Arrow link — slides right on hover */}
        <span
          className="text-[#D4A520] text-sm font-semibold flex items-center gap-1"
          style={{ transition: 'gap 300ms cubic-bezier(0.4,0,0.2,1)' }}
        >
          {link}
          <span
            style={{
              display: 'inline-block',
              transform: hovered ? 'translateX(4px)' : 'translateX(0)',
              transition: 'transform 300ms cubic-bezier(0.4,0,0.2,1)',
            }}
          >→</span>
        </span>
      </div>
    </div>
  );
};

const FeaturesSection = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="features" className="py-8 sm:py-14 bg-[#EEF1FA]" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className={`text-center mb-6 sm:mb-10 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <div className="inline-flex items-center gap-2 bg-[#D4A520]/15 border border-[#D4A520]/30 rounded-full px-4 py-1.5 mb-4">
            <span className="text-[#D4A520] text-xs font-semibold tracking-widest uppercase">Platform Features</span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Everything You Need to Build Wealth
          </h2>
          <p className="text-[#0B1F3B]/60 text-base sm:text-lg max-w-2xl mx-auto">
            One platform. Six powerful tools. Infinite possibilities for your financial future.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5">
          {FEATURES?.map((feature, i) => (
            <FeatureCard key={feature?.title} {...feature} index={i} visible={visible} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
